export default __webpack_public_path__ + "static/media/insights.792bd8d6.svg";